import { render, staticRenderFns } from "./DeviceVersion.vue?vue&type=template&id=971b2edc&scoped=true"
import script from "./DeviceVersion.vue?vue&type=script&lang=js"
export * from "./DeviceVersion.vue?vue&type=script&lang=js"
import style0 from "./DeviceVersion.vue?vue&type=style&index=0&id=971b2edc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971b2edc",
  null
  
)

export default component.exports